import { Component, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { Subject } from 'rxjs';
import { delay, skip, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'player-sheet',
  templateUrl: './sheet.component.html',
  styleUrls: ['./sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe],
})
export class Sheet {
  readonly ss = inject(SurveyStore);

  hiding$ = new Subject();
  @Output() hidden = this.hiding$.pipe(startWith(false), skip(1), delay(300));
}
